export enum LoanStatusType {
    Approved = 0,
    Outstanding = 1,
    Repaid = 2,
    Deleted = 3,
    Lost = 4,
}
